import { render } from "./RegisterHeader.vue?vue&type=template&id=afd99a9a"
import script from "./RegisterHeader.vue?vue&type=script&lang=js"
export * from "./RegisterHeader.vue?vue&type=script&lang=js"

import "./RegisterHeader.vue?vue&type=style&index=0&id=afd99a9a&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__